import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { getActiveSpan, spanToBaggageHeader, spanToTraceHeader } from '@sentry/angular';

export const sentryTraceInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const activeSpan = getActiveSpan();
    if (!activeSpan) {
        return next(req);
    }

    const sentryTrace = spanToTraceHeader(activeSpan);
    const baggage = spanToBaggageHeader(activeSpan);

    const headers: Record<string, string> = { 'sentry-trace': sentryTrace };
    if (baggage) {
        headers['baggage'] = baggage;
    }

    return next(req.clone({ setHeaders: headers }));
};
